// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.scrollable-requester-list[data-v-09126bfc] {\r\n  max-height: 400px;\r\n  /* Adjust this value based on your design needs */\r\n  overflow-y: auto;\r\n  /* Enables vertical scrolling */\r\n  border: 1px solid #ccc;\r\n  /* Optional: adds a border around the list */\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
